<template>
  <div class="interview-container">
    <div class="interview-card" v-for="(i, k) in interview" :key="k"
         data-aos="fade-zoom-in"
         data-aos-delay="100"
         data-aos-easing="ease-out"
         data-aos-duration="400"
         data-aos-anchor-placement="top-bottom">
      <div class="card-top">
        <div class="dots-small"></div>
        <div class="floating-bg">
          <span>{{ i.question }}</span>
        </div>
      </div>

      <div class="card-bottom">
        <p>{{ i.answer }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Interview',
  data () {
    return {
      interview: null
    }
  },
  methods: {
    fetchText () {
      axios.get('/text.json').then(response => {
        this.interview = response.data['interview']
      })
    }
  },
  mounted () {
    this.fetchText()
  }
}
</script>

<style scoped lang="scss">

  @media screen and (max-width: 800px) {
    .interview-card {
      width: 100% !important;
    }

    .card-top {
      height: 132px !important;
    }

    .interview-container {
      padding: 128px 24px !important;
      .card-bottom {
        p {
          text-align: left !important;
        }
      }
    }
  }

  .interview-container {
    display: flex;
    flex-direction: column;
    padding: 128px 48px 64px 48px;
    justify-content: center;
    align-items: center;

    .interview-card {
      width: 80%;
      background-color: white;
      margin: 36px 0;
      border-radius: 4px;
      box-shadow: 0px 0px 8px 0px rgba(22, 31, 58, 0.2);
      display: flex;
      flex-direction: column;
      max-width: 800px;

      .card-top {
        position: relative;
        color: $text-light;
        height: 50px;
        padding: 24px;

        .floating-bg {
          position: absolute;
          background-color: $primary-dark-blue;
          box-shadow: 0px 0px 12px 0px rgba(22, 31, 58, 0.5);
          top: -6px;
          right: -6px;
          bottom: -6px;
          left: -6px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            text-align: justify;
            font-weight: 500;
            padding: 0 12% 0 24px;
            font-size: 18px;
            width: 100%;
          }
        }
      }

      .card-bottom {
        padding: 24px;
        p {
          text-align: justify;
          padding-left: 12%;
          font-size: 18px;
          line-height: 24px;
        }
      }
    }
  }

  .card-top::before {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 10px solid $background-dark;
    border-right: 10px solid transparent;
    border-top: 10px solid $background-dark;
    border-bottom: 10px solid transparent;
    left: 20px;
    bottom: -24px;
    border-bottom-left-radius: 4px;
    filter: drop-shadow(0px 2px 4px rgba(22, 31, 58, 0.4));
  }

  .card-bottom::before {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    border-right: 10px solid white;
    border-left: 10px solid transparent;
    border-top: 10px solid white;
    border-bottom: 10px solid transparent;
    right: 20px;
    bottom: -20px;
    border-bottom-right-radius: 4px;
    filter: drop-shadow(2px 6px 6px rgba(0,0,0,0.2));
  }
</style>
